import Klarna from './Klarna';
import CartHelper from './CartHelper';

export default class Cart {
    
    constructor() {
        this.el = $('.cart');
        this.klarna = new Klarna();
        this.klarna.enable();
        if (!this.el.length) {
            return false;
        }
        this.current = null;
        this.init();

        document.addEventListener("cartUpdateEvent", () => {
            this.el.load('/cart/GetCartInMenu');
        });
    }

    init() {
        const context = this;
        initHandlers();
    }
}

function initHandlers() {
    const cartContinueButton = document.getElementById("cartContinue");
    const certificateCodeButton = document.getElementById("certificateCode");
    const popUpButton = document.getElementById("popUpButton");
    const linkingSuccessModal = document.getElementById("linkingSuccessModal");
    const membershipVerifyModal = document.getElementById("membershipVerifyModal");
    if (membershipVerifyModal) {
        $("#membershipVerifyModal").modal('show');
    }
    const externalLoginVerifyModal = document.getElementById("externalLoginVerifyModal");
    if (externalLoginVerifyModal) {
        $("#externalLoginVerifyModal").modal('show');
    }
    if (cartContinueButton) {
        cartContinueButton.onclick = getCartContinueHandler;
    }


    if (popUpButton) {
        window.onload = function() {
            popUpButton.click();
        }
    }

    if (linkingSuccessModal) {
        window.onload = function() {
            $("#linkingSuccessModal").modal('show');
        }
    }
}

function getCartContinueHandler() {
    document.getElementById("cartContinue").disabled = true;

    const cartIndexViewModel = CartHelper.populateCartIndexViewModel();

    $.ajax({
        url: "/Cart/Index",
        dataType: "json",
        type: "POST",
        data: { model: cartIndexViewModel },
        success: function (data) {
            window.location.href = data.url;
        }
    });
}